export const BirdConstants = {
  listPageSize: 20,
  authenticatedRefreshInterval: 60, // 1 min.
  unauthenticatedRefreshInterval: 2 * 60, // 2 min.
  linkMaxLength: 20,
  defaultDomain: "baq.run",
};
